export default __webpack_public_path__ + "static/media/KZ.T.18.2076 black.6ce67755.svg";